import React, { useState, useEffect } from 'react';
import { colors } from '../styles/colors';
import { fonts, fontWeights } from '../styles/fonts';
import { content } from '../constants/content';

function Hero() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section id="home" style={isMobile ? styles.heroMobile : styles.hero}>
      <div style={styles.videoContainer}>
        <video 
          autoPlay 
          loop 
          muted 
          playsInline
          style={styles.video}
        >
         <source src="/hero-video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div style={styles.overlay}></div>
      </div>
      
      <div style={isMobile ? styles.contentWrapperMobile : styles.contentWrapper}>
        <p style={isMobile ? styles.patentMobile : styles.patent}>
          {content.hero.patentText}
        </p>
        
        <h1 style={isMobile ? styles.titleMobile : styles.title}>
          {content.hero.title}
        </h1>
        
        <p style={isMobile ? styles.subtitleMobile : styles.subtitle}>
          {content.hero.subtitle}
        </p>
      </div>
    </section>
  );
}

const styles = {
  hero: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '90vh',
    padding: '80px 40px',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  heroMobile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: '60px 20px',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  videoContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 0,
  },
  video: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1,
  },
  contentWrapper: {
    maxWidth: '1200px',
    zIndex: 2,
    position: 'relative',
  },
  contentWrapperMobile: {
    maxWidth: '100%',
    zIndex: 2,
    position: 'relative',
    padding: '0 10px',
  },
  patent: {
    fontSize: '14px',
    fontWeight: fontWeights.medium,
    fontFamily: fonts.primary,
    color: colors.primary,
    fontStyle: 'italic',
    marginBottom: '30px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    textShadow: '0 2px 4px rgba(0,0,0,0.3)',
  },
  patentMobile: {
    fontSize: '11px',
    fontWeight: fontWeights.medium,
    fontFamily: fonts.primary,
    color: colors.primary,
    fontStyle: 'italic',
    marginBottom: '20px',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    textShadow: '0 2px 4px rgba(0,0,0,0.3)',
  },
  title: {
    fontSize: '72px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.white,
    lineHeight: '1.1',
    maxWidth: '1100px',
    margin: '0 auto 40px auto',
    textShadow: '0 2px 10px rgba(0,0,0,0.5)',
  },
  titleMobile: {
    fontSize: '36px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.white,
    lineHeight: '1.2',
    maxWidth: '100%',
    margin: '0 auto 25px auto',
    textShadow: '0 2px 10px rgba(0,0,0,0.5)',
  },
  subtitle: {
    fontSize: '22px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: '#f0f0f0',
    lineHeight: '1.7',
    maxWidth: '900px',
    margin: '0 auto',
    textShadow: '0 2px 4px rgba(0,0,0,0.3)',
  },
  subtitleMobile: {
    fontSize: '16px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: '#f0f0f0',
    lineHeight: '1.6',
    maxWidth: '100%',
    margin: '0 auto',
    textShadow: '0 2px 4px rgba(0,0,0,0.3)',
    padding: '0 5px',
  },
};

export default Hero;